import { Injectable, OnDestroy } from '@angular/core';
import { SpinnerService } from '@core/spinner.service';
import { DigitalResourceIconService } from '@ece/api-services/digital-resource-icon.service';
import { EceApiService } from '@ece/api-services/ece-api.service';
import { EceProductService } from '@ece/api-services/ece-product.service';
import { DragFormatService } from '@ece/component-services/drag-format-service';
import { WeeklyPlannerCardResizeService } from '@ece/component-services/weekly-planner-card-resize.service';
import { WeeklyPlannerService } from '@ece/component-services/weekly-planner.service';
import { MessageEventService } from '@services/message-event/message-event.service';
import { HeaderService } from '@shared/header/header-service';
import { ImportStateService } from '@shared/import-state.service';
import { ViewerService } from '@shared/viewer/viewer.service';
import { StudentStateService } from '@students/helpers/student-state.service';
import { Subscription } from 'rxjs';
import { TeacherService } from '../../../teachers/teachers-service';
import { AppConfigService } from '../../appconfig.service';
import { AvatarService } from '../../avatar.service';
import { ProductService } from '../../product.service';
import { ReportsService } from '../../reports.service';
import { UserService } from '../../user.service';
import {
  ProductEventNotificationService
} from '../announcement-notifications/product-event-notification/product-event-notification.service';
import { MasqueradeService } from '../masquerade/masquerade.service';
import { QueryParamService } from '../query-param/query-param.service';
import { UserApiService } from '../user/user-api.service';
import { LogoutEventService } from './logout-event-service/logout-event.service';

/** Service injected in the App Component allows for management of all Services. */
@Injectable({
  providedIn: 'root'
})
export class StatefulServicesManagerService implements OnDestroy {

  /** Services provided in root that need reset during logout. */
  rootServicesForLogout: any[] = [];
  private subscriptions = new Subscription();

  constructor(
    private studentStateService: StudentStateService,
    private teacherService: TeacherService,
    private headerService: HeaderService,
    private logoutEventService: LogoutEventService,
    private digitalResourceIconService: DigitalResourceIconService,
    private eceApiService: EceApiService,
    private eceProductService: EceProductService,
    private dragFormatService: DragFormatService,
    private weeklyPlannerService: WeeklyPlannerService,
    private appConfigService: AppConfigService,
    private avatarService: AvatarService,
    private productService: ProductService,
    private reportsService: ReportsService,
    private userService: UserService,
    private productEventNotificationService: ProductEventNotificationService,
    private masqueradeService: MasqueradeService,
    private queryParamService: QueryParamService,
    private userApiService: UserApiService,
    private weeklyPlannerCardResizeService: WeeklyPlannerCardResizeService,
    private messageEventService: MessageEventService,
    private viewerService: ViewerService,
    private spinnerService: SpinnerService,
    private importStateService: ImportStateService,
  ) {
    this.rootServicesForLogout = [
      this.studentStateService,
      this.teacherService,
      this.headerService,
      this.digitalResourceIconService,
      this.eceApiService,
      this.eceProductService,
      this.dragFormatService,
      this.weeklyPlannerService,
      this.appConfigService,
      this.avatarService,
      this.productService,
      this.reportsService,
      this.userService,
      this.productEventNotificationService,
      this.masqueradeService,
      this.queryParamService,
      this.userApiService,
      this.weeklyPlannerCardResizeService,
      this.messageEventService,
      this.viewerService,
      this.spinnerService,
      this.importStateService,
    ];

    // Subscribe to logout events and reset all services when logout occurs
    this.subscriptions.add(
      this.logoutEventService.logout$.subscribe(() => {
        this.resetRootServicesForLogout();
      })
    );
  }

  /** Calls the `reset` function, if it exists, for all root-provided services. */
  resetRootServicesForLogout() {
    this.rootServicesForLogout.forEach((service) => {
      if (service.reset) {
        service.reset();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
